import React, { useEffect, useState } from "react";

// The add-in only works live (no offline data). Tell the user as soon as the
// connection drops instead of letting saves fail silently.
export default function ConnectionBanner() {
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
  const [justRestored, setJustRestored] = useState(false);

  useEffect(() => {
    let timer = null;
    const goOffline = () => { setOnline(false); setJustRestored(false); };
    const goOnline = () => {
      setOnline(true);
      setJustRestored(true);
      clearTimeout(timer);
      timer = setTimeout(() => setJustRestored(false), 3000);
    };
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (online && !justRestored) return null;
  const ok = online;
  return (
    <div
      key={ok ? "restored" : "offline"}
      data-no-translate="true"
      role="status"
      style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000,
        padding: "8px 12px", textAlign: "center", fontSize: 12, fontWeight: 700,
        background: ok ? "#16a34a" : "#dc2626", color: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
      }}
    >
      {ok ? "✓ კავშირი აღდგა" : "⚠ ინტერნეტ კავშირი არ არის — ცვლილებები ვერ შეინახება"}
    </div>
  );
}
